import { BaseTitle } from "./BaseTitle.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/typography/titles/Title1.tsx
const Title1 = ({ children, color = "gray", size = "2rem", ta, "data-testid": testId }) => /* @__PURE__ */ jsx(BaseTitle, {
	order: 1,
	size,
	color,
	ta,
	"data-testid": testId,
	children
});

//#endregion
export { Title1 };